import React, {Component} from 'react';
import {SESSION_USER,APP_TITLE} from '../../constants';
import Loading from '../../common/Loading';
import NotFound from '../../common/NotFound';
import ServerError from '../../common/ServerError';
import {PeopleTable} from './PeopleTable';
import {getAllPeople,deletePeopleById} from '../../util/APIUtils';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';

class People extends Component {
	 constructor(props) {
        super(props);
        this.state = {
            dataSet:[],
            loading: true,
            deleteId: '',
            show: false
        };
        this.handleClick = this.handleClick.bind(this);
        this.deletePeople = this.deletePeople.bind(this);
 }


 componentDidMount() {
               
                let user = JSON.parse(localStorage.getItem(SESSION_USER));

                getAllPeople(user.id)
                .then(response => {
                      // console.log(response);
                       this.setState({dataSet:response,loading: false});
                }).catch(error => {
                   if(error.status === 404) {
                        this.setState({
                            notFound: true,
                        });
                    } else {
                        this.setState({
                            serverError: true,
                        });        
                    }
                });

 }
    componentWillMount() {
        document.body.addEventListener('click', this.handleClick);
    }
    handleClick(event) {
        if(event.target.classList.contains('delete')) {
            var id = event.target.getAttribute('data-id');
            this.setState({
                deleteId : id,
                show: true
            });
        }
    }

    deletePeople(id){
        
   deletePeopleById(id)
            .then(response => {
                this.setState({ show: false , deleteId: ''});
                window.location.href='/peoples';
            }).catch(error => {
            if(error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });

    }

	
    render(){

        if(this.state.notFound) {
            return <NotFound />;
        }

        if(this.state.serverError) {
            return <ServerError />;
        }

         if(this.state.loading) {
          // return 'Loading...'
           return <Loading />;
        } 
    return (


          <div>
        

       <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor m-b-0 m-t-0">Employee</h3>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Home</li>
                            <li className="breadcrumb-item active">Employee</li>
                        </ol>
                    </div>
                    <div className="col-md-7 col-4 align-self-center">
                            
		                        <div className="d-flex m-t-10 justify-content-end">
		                           
			                            <div className="d-flex m-r-20 m-l-10 hidden-md-down">
                                          <a href="/people/0" className="btn-rounded btn waves-effect waves-light btn-primary" >Create Employee</a>   
                                           
			                              
			                            </div>
			                          
		                             
                         
                                 </div>
                    </div>


                    
            
       </div>
               <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                    <PeopleTable data={this.state.dataSet} cols={this.tablecol}></PeopleTable>
                                    <SweetAlert
                                    show={this.state.show}
                                    title={APP_TITLE}
                                    text="Are you sure you want to delete this People. If not, click Cancel."
                                    icon="warning"
                                    showCancelButton
                                    confirmButtonColor="#1e88e5"
                                    cancelButtonColor="#2f3d4a"
                                    onConfirm={() => {
                                            this.deletePeople(this.state.deleteId); 
                                    }}
                                 //   onConfirm={() => }
                                    onCancel={() => this.setState({ show: false, deleteId: '' })}
                                />
                            </div>
                        </div>
                     </div> 
                  </div>   
                  </div>    
          );
  }

    tablecol=[

                    { title: "Id","mData": "id"},
		    
                    {  
                          "title": "Employee Name",
                          "render": function(data, type, full, meta) {
                            var img='<img src="../static/assets/images/people.png" width="40"/>';
                            if(full.profileLogo){
                                img='<img src="data:image/png;base64,'+full.profileLogo+'" width="40"/>'
                            }

                           
                            return  img+' '+full.firstName+' '+full.lastName;
                          }   
                    },
		            { title: "Email" ,"mData": "email"},
                 { title: "Zoho Id" ,"mData": "zohoId"},
		            { title: "Timezone" ,"mData": "timezone"},
                    {
                        title: "Role" ,"mData": "roles[0].name",
                       "render": function(data, type, full, meta) {
                                //console.log(data)
                                if(data==='ROLE_USER'){
                                     return 'User';
                                }else if(data==='ROLE_ADMIN'){
                                     return "Admin";
                                }
                                return data;
                       }
                    },
		           // { title: "Zoho Id" ,"mData": "appId"},
		            {  
		            	  "mData": "id",
		                  "render": function(data, type, full, meta) {
                            return "<a href='people/" + data + "'>Edit</a>";
                          }   
                    },{
                        "mData": "id",
                        "render": function(data, type, full, meta) {
                         //   console.log(full);
                            return "<a href='javascript:' data-id='"+data+"' class='delete' >Delete</a>";
                        }
                    }
		    ];


  
}
	export default People;